import { render, staticRenderFns } from "./avoidedCosts.vue?vue&type=template&id=3cc48a3c&scoped=true"
import script from "./avoidedCosts.vue?vue&type=script&lang=js"
export * from "./avoidedCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc48a3c",
  null
  
)

export default component.exports